import api from './interceptor'

export const getPlanPriceByCustomer = params => {
  return api.get('/tyre/loyalty/queryTyreLoyaltyPlanPriceByCustomer', { params })
}
// 获取品牌。下拉
export const getBrandPickerData = params => {
  return api.get('/tyre/product/queryBrandOrSpecList', { params })
}
// 插入购物车
export const getVehiclePickerData = params => {
  return api.get('/basis/vehiclePickerData', { params })
}
export const getTyresList = params => {
  return api.get('/tyres/get', { params })
}
// export const getTyresList = params => {
//   return api.post('/tyres/get', params)
// }
export const getSystemConfig = params => {
  return api.get('/tyres/configInfo', { params })
}
export const getTyresDetail = params => {
  return api.get('/tyres/detail', { params })
}
export const getAllProvinces = params => {
  return api.get('/basis/getAllProvinces', { params })
}
// 轮胎经销商
export const getCommodities = params => {
  return api.get('/tyres/commodities', { params })
}

// 首页搜索-轮胎列表
export const getTyresListByKeyword = params => {
  return api.get('/tyres/search', { params })
}

//轮胎单独结算，使用商城优惠
export const getTyresApplyCoupons = params => {
  return api.get('/rightCoupon/tyreCouponList', { params })
}
//轮胎包优惠券 tyres/tyrePackageRightList
export const tyrePackageRightList = params => {
  return api.post('/tyres/tyrePackageRightList', params)
}
// tyrePackageRightListNotCanUse
export const tyrePackageRightListNotCanUse = params => {
  return api.post('/tyres/tyrePackageRightListCanUse', params)
}
// 轮胎包优惠券价格计算
export const getTyrePackageDiscount = params => {
  return api.get('/tyres/getTyrePackageDiscount', { params })
}
// 计划详情列表车辆checkTyrePackage
export const getcheckTyrePackageUse = params => {
  return api.get('/tyres/checkTyrePackageUse', { params })
}
//轮胎单独结算，获取六位码优惠券信息
export const getSixCouponMsg = params => {
  return api.get('/couponCenter/checkCoupons', { params })
}
//轮胎单独结算，订单提交
export const postTyreOrder = params => {
  return api.post('/order/add', params)
}
// 获取默认经销商
export const getDefaultDealer = params => {
  return api.get('/customer/getDefaultDealer', { params })
}
// 获取默认经销商对应的数据
export const getDefaultCommoditie = params => {
  return api.get('/tyres/commoditie', { params })
}

// 获取轮胎可用优惠券列表
export const getTyreUsableCounponList = params => {
  return api.get('/right/coupon/tyreUsableCounponList', { params })
}
//==================== 以下为轮胎尊享接口===================
// 获取用户车辆信息
export const getVehicle = params => {
  return api.get('/tyres/exclusive/vehicle', { params })
}
// 轮胎信息
export const getTyres = params => {
  return api.get('/tyres/exclusive/tyres', { params })
}
// 尊享轮胎订单详情
export const getOrdersDetail = params => {
  return api.get('/tyres/exclusive/ordersDetail', { params })
}
// 补偿信息
export const getMyInsuranceNoTime = params => {
  return api.get('/tyres/exclusive/myInsuranceNoTime', { params })
}
// 尊享轮胎补偿记录
export const getMyInsurance = params => {
  return api.get('/tyres/exclusive/myInsurance', { params })
}
// 删除订单图片-MOBILE端
export const getDeletePictures = params => {
  return api.get('/tyres/exclusive/deletePictures', { params })
}
//上传轮胎图片
export const uploadTyreImage = params => {
  return api.post('/order/pictures', params)
}
//删除轮胎图片
export const deleteTyreImage = params => {
  return api.get('/order/pictures', { params })
}
//获取库存信息
export const getInventory = params => {
  return api.get('/tyres/commoditieByDealer', { params })
}
//自动领取优惠券
export const autoGetCoupon = params => {
  return api.get('/rightCoupon/autoGetTyreCoupon', { params })
}
